import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

const errorPage = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 20px;
  padding: 20px;
  box-sizing: border-box;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  background-color: ${colors.white};
  box-shadow: 1px 1px 5px 0 ${colors.custom.gray20};
  border-radius: 5px;
  button {
    margin: 20px auto 0;
  }
  > span {
    display: block;
    margin-top: 20px;
  }
  > svg {
    width: 200px;
    height: 200px;
  }
`;

export default {
  errorPage,
};
